import CryptoJS from "crypto-js";
import { Buffer } from "buffer";

export const decrypted = (ciphertext: any) => {
  const bytes =
    ciphertext && CryptoJS.AES.decrypt(ciphertext, "qwerty_asdf_zxc");
  const originalText = bytes?.toString(CryptoJS.enc.Utf8);

  const buffer = originalText && Buffer.from(originalText, "base64");
  const decodedData = buffer && JSON.parse(buffer.toString("utf-8") || "{}");
  return decodedData;
};

export const encrypted = (data: any) => {
  const buffer = data && Buffer.from(JSON.stringify(data));
  const encodedData = buffer && buffer.toString("base64");

  const ciphertext = CryptoJS.AES.encrypt(
    encodedData,
    "qwerty_asdf_zxc"
  ).toString();
  return ciphertext;
};
